import { render, staticRenderFns } from "./Prefs.vue?vue&type=template&id=0550abee&scoped=true&"
import script from "./Prefs.vue?vue&type=script&lang=js&"
export * from "./Prefs.vue?vue&type=script&lang=js&"
import style0 from "./Prefs.vue?vue&type=style&index=0&id=0550abee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0550abee",
  null
  
)

export default component.exports